import { throttle } from 'lodash';

export class ElementScrollingModel {

  isBeingScrolled = false;

  element;

  _scrollTimeoutId;

  constructor(element) {
    this.element = element;
    this._createScrollHandler();
    element.addEventListener('scroll', this.handleScroll);
  }

  handleScroll;

  dispose = () => {
    if (this.element) {
      this.element.removeEventListener('scroll', this.handleScroll);
      this.element = null;
    }
  }

  _createScrollHandler = () => {
    this.handleScroll = throttle(() => {
      window.clearTimeout(this._scrollTimeoutId);
      this.isBeingScrolled = true;
      this._scrollTimeoutId = window.setTimeout(() => { this.isBeingScrolled = false; }, 300);
    }, 290);
  }


}
